import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { API } from './url';
const TrackATrader = () => {

  const [profile, setProfile] = useState([]);
  useEffect(() => {
    AOS.init({ duration: 2000 });
    getData()

  }, [])

  const sum3UserAccessToken = localStorage.getItem('sum3UserAccessToken');

  const getData = async () => {
    try {
      const response = await fetch(`${API}/users/unique-id`, {
        method: 'post',
        headers: {
          Accept: '/',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sum3UserAccessToken}`
        },
      });

      if (!response.ok) {
        throw new Error('Failed to Received Question');
      }
      const data = await response.json();
      setProfile(data?.payload)
      return data?.payload
    } catch (error) {
      Swal.fire({
        text: error,
        icon: "error"
      });
    }
  }

  return (
    <div>
      <div class='d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>

        <div class='d-flex align-items-center justify-content-center  col-11 m-auto rounded-4 bg-dark ' style={{ height: '80%' }}>
          <div class='col-11 m-auto'>
            <p class='mfs-7 fwh org' data-aos="zoom-in">Track A Trader</p>
          </div>
        </div>
      </div>
      <div class=" mb-5  rounded-4 col-11 m-auto p-3" style={{ "background": " rgb(245, 245, 245)" }}>
        {profile?.data ? <iframe id="user-stats" src={`https://trackatrader.com/private/user-statistics?business_id=532&token=885107d983add63432e4fb4f2961e99f&userid=${profile?.data}&padding=1`}
          frameborder="0" scrolling="no" allow="clipboard-read; clipboard-write; fullscreen"
          style={{ "width": "100%", "minHeight": "99vh", "height": "936px" }}>
        </iframe> : ''}
      </div>
    </div >
  )
}

export default TrackATrader